import React from "react";
import { callApi } from "../../utils/api";
import { Bank } from "./ManageBank";
import { ToastsStore } from "react-toasts";

declare var $: any;

interface AllProps {
  selectedBank: Bank;
  listBank: any;
}
class AddBank extends React.Component<AllProps> {
  state = {
    bankdetail: { id: 0, bank_id: 0, name: "" },
    isLoading: false
  };
  componentWillReceiveProps(nextState) {
    this.setState({ bankdetail: nextState.selectedBank });
  }
  handleChange = (e: any) => {
    const bankdetail: any = this.state.bankdetail;
    bankdetail[e.target.name] = e.target.value;
    this.setState({ bankdetail });
  };
  handleSaveResponse = (response: any) => {
    if (
      response.result === false ||
      (response.message && response.message.indexOf("Already Exist") !== -1)
    ) {
      ToastsStore.error(response.message || "Failed to save bank");
      return;
    }
    this.props.listBank();
    $("#bank-form").modal("hide");
    ToastsStore.success(response.message || "Bank saved successfully");
  };
  saveBank = () => {
    const bankdetail = { ...this.state.bankdetail };
    bankdetail.name = bankdetail.name ? bankdetail.name.trim() : "";
    if (!bankdetail.name) {
      ToastsStore.error("Bank name is required");
      return;
    }
    this.setState({ isLoading: true, bankdetail });
    if (bankdetail.id) {
      bankdetail.id = Number(bankdetail.id);
      callApi("POST", "bank_update.php", bankdetail)
        .then(res => res.data)
        .then(response => {
          this.handleSaveResponse(response);
        })
        .catch(err => {
          console.log(err);
          ToastsStore.error("Something went wrong, please try again");
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    } else {
      callApi("POST", "bank_create.php", bankdetail)
        .then(res => res.data)
        .then(response => {
          this.handleSaveResponse(response);
        })
        .catch(err => {
          console.log(err);
          ToastsStore.error("Something went wrong, please try again");
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    }
  };
  render() {
    return (
      <div
        className="modal fade"
        id="bank-form"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Bank Form</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label className="col-form-label">Bank Name:</label>{" "}
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Bank Name"
                    onChange={e => {
                      this.handleChange(e);
                    }}
                    value={
                      this.state.bankdetail.name
                        ? this.state.bankdetail.name
                        : ""
                    }
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={this.state.isLoading}
                onClick={this.saveBank}
              >
                {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddBank;
